module.exports = __webpack_public_path__ + "img/gift-04-c3.74a906a5.png";